import React from 'react';
import { SuggestionPhrase } from '../utils/phrasesData';
import captainHeroImage from '../captAIn_03.png';
import marinaioCropImage from '../marinaio_crop.png';
import captainLogo from '../CAPTAIN_Logo_Primario.png';

interface SuggestionButtonsProps {
  onPhraseClick: (phrase: SuggestionPhrase) => void;
  isDarkMode?: boolean;
  disabled?: boolean;
}

const HERO_DESCRIPTION =
  "Non un semplice chatbot, ma il tuo amico skipper di fiducia: ti aiuta a capire, confrontare e scegliere la vacanza giusta con trasparenza, esperienza reale e feedback di chi c'e gia stato, come farebbe un amico che il mare lo conosce davvero.";

const HERO_TITLE_PREFIX = 'Lasciati ispirare da';

const HERO_SUGGESTION_PHRASES: SuggestionPhrase[] = [
  {
    id: 'hero_payments_boat_skipper_costs',
    text: 'Hai dubbi su pagamenti, barca, skipper o costi? Ti aiuto a capire tutto prima di prenotare.',
    backendPayload: 'Hai dubbi su pagamenti, barca, skipper o costi? Ti aiuto a capire tutto prima di prenotare.',
  },
  {
    id: 'hero_costs_details_included',
    text: 'Ti chiarisco costi, dettagli e cosa e incluso.',
    backendPayload: 'Ti chiarisco costi, dettagli e cosa e incluso.',
  },
  {
    id: 'hero_boat_choice_advice',
    text: 'Non sai quale barca scegliere? Ti consiglio io.',
    backendPayload: 'Non sai quale barca scegliere? Ti consiglio io.',
  },
  {
    id: 'hero_destinations_help',
    text: 'Quali sono le vostre destinazioni?',
    backendPayload: 'Quali sono le vostre destinazioni?',
  },
  {
    id: 'hero_skipper_included_help',
    text: 'Cerco una barca con skipper incluso, mi aiuti?',
    backendPayload: 'Cerco una barca con skipper incluso, mi aiuti?',
  },
];

const SuggestionButtons: React.FC<SuggestionButtonsProps> = ({
  onPhraseClick,
  isDarkMode,
  disabled,
}) => {
  return (
    <div className={`suggestion-buttons-container ${isDarkMode ? 'dark' : ''}`}>
      <div className="empty-chat-hero-card">
        <picture>
          <source
            media="(min-width: 769px) and (max-width: 1366px)"
            srcSet={marinaioCropImage}
          />
          <img
            src={captainHeroImage}
            alt="Skipper CAPTAIN al timone"
            className="empty-chat-hero-image"
          />
        </picture>
        <div className="empty-chat-hero-overlay">
          <div className="empty-chat-title-row">
            <span className="empty-chat-title-prefix">{HERO_TITLE_PREFIX}</span>
            <img
              src={captainLogo}
              alt="CAPTAIN"
              className="empty-chat-title-logo"
            />
          </div>
          <p className="empty-chat-hero-description">{HERO_DESCRIPTION}</p>
        </div>
      </div>
      <div className="suggestion-buttons-list">
        {HERO_SUGGESTION_PHRASES.map((phrase) => (
          <button
            key={phrase.id}
            className={`suggestion-button ${isDarkMode ? 'dark' : ''}`}
            onClick={() => onPhraseClick(phrase)}
            disabled={disabled}
          >
            {phrase.text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionButtons;
